import { useEffect } from "react";
import { AspectRatio, Box, Container, Flex, Heading, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import Button from "../../components/Button";
import useComponentsStore from "../../stores/ComponentsStore";
import { typedSxMap } from "../../utils/typedSxMap";
import SliderShow from "./components/SlideShow";
import WelcomeBoxes from "./components/WelcomeBoxes";
import { HiOutlineCube } from "react-icons/hi";
import { PiArrowSquareOut } from "react-icons/pi";

export default function Welcome() {
  const components = useComponentsStore((state) => state.components);
  const { mainPage: MainComponents } = components;
  const styles = typedSxMap({
    container: {
      maxW: 1230,
      pb: 2,
      mt: 2,
      flexDirection: "column",
      margin: "0 auto",
    },
    stackWrapper: {
      gap: { base: 3, sm: 1, md: 3 },
      py: 4,
      paddingBottom: 3,
      flex: 1,
      flexDirection: { base: "column", sm: "column", md: "row", lg: "row", xl: "row", "2xl": "row" },
    },
    iframeContainer: {
      position: "relative",
      height: "0",
      paddingBottom: "56.25%",
      width: "100%",
      overflow: "hidden",
      rounded: "2xl",
      boxShadow: "2xl",
    },
    welcomeBoxes: {
      mt: { base: 4, md: 0 },
      textAlign: { base: "center", md: "initial" },
      width: { base: "100%", sm: "100%", md: "60%", lg: "70%", xl: "90%", "2xl": "100%" },
    },
    video: {
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      w: "100%",
      maxW: { base: "100%", lg: "700px", xl: "700px", "2xl": "800px" },
    },
  });
  useEffect(() => {
    localStorage.setItem("isFirstLogin", "false");
  }, []);
  return (
    <>
      <Container sx={styles.container}>
        <Heading lineHeight={1.1} fontWeight={600} fontSize={{ base: "2xl", sm: "3xl", lg: "3xl" }}>
          <Text as={"span"} position={"relative"} lineHeight={"38px"}>
            Welcome to TableFlow
          </Text>
        </Heading>
        <Text as={"span"} fontSize={"medium"} color={useColorModeValue("#344054", "#98A2B3")} lineHeight={"24px"}>
          Onboard customer data faster than ever before
        </Text>
        <Stack sx={styles.stackWrapper} align={"center"} justifyContent={"space-between"}>
          <Flex sx={styles.video}>
            <Box position={"relative"} sx={styles.iframeContainer} minWidth={{ base: "100%", "2xl": 790 }}>
              <AspectRatio ratio={16 / 9}>
                <iframe
                  title="TableFlow 60 Second Demo"
                  src="https://www.loom.com/embed/fd9e456ecead4471a167271a26554ef0?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true"
                  allow="autoplay; fullscreen; encrypted-media; picture-in-picture;"
                  allowFullScreen
                  style={{ width: "100%", height: "100%" }}></iframe>
              </AspectRatio>
            </Box>
          </Flex>
          <Box maxW="7xl" sx={styles.welcomeBoxes}>
            <WelcomeBoxes />
          </Box>
        </Stack>
        <Stack
          direction={{ base: "column", md: "row" }}
          justifyContent={{ base: "flex-start", md: "space-between" }}
          alignItems={{ base: "flex-start", md: "center" }}
          flex={1}
          p={3}
          mt={5}
          border={"1px solid"}
          borderColor={useColorModeValue("#D0D5DD", "#344054")}
          backgroundColor={useColorModeValue("#FCFCFD", "#171A20")}
          borderRadius={10}>
          <Flex align="center">
            <HiOutlineCube size={"42"} style={{ color: "#98A2B3" }} />
            <Box ml={3}>
              <Text fontSize={"16px"} mb={"0 !important"} fontWeight={500}>
                See an example
              </Text>
              <Text as={"p"} fontWeight={400} color={useColorModeValue("#344054", "#D0D5DD")} fontSize={"14px"}>
                Try out the TableFlow importer in our demo application{" "}
              </Text>
            </Box>
          </Flex>
          <Button
            icon={<PiArrowSquareOut size={18} />}
            variants={["primary"]}
            onClick={() => window.open("https://example-crm.tableflow.com/", "_blank")}>
            Open Importer Demo
          </Button>
        </Stack>
        <Stack>
          <SliderShow />
        </Stack>
      </Container>
      {MainComponents && <MainComponents />}
    </>
  );
}
